const sanitizeDigits = (value) => String(value ?? "").replace(/\D/g, "").slice(0, 11);

const sanitizeDocument = (value) => String(value ?? "").toUpperCase().replace(/[^0-9A-Z]/g, "").slice(0, 14);

export const maskCPF = (value) => {
    const digits = sanitizeDigits(value);

    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
    if (digits.length <= 9) return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;

    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
};

export const maskCNPJ = (value) => {
    const document = sanitizeDocument(value);

    if (document.length <= 2) return document;
    if (document.length <= 5) return `${document.slice(0, 2)}.${document.slice(2)}`;
    if (document.length <= 8) return `${document.slice(0, 2)}.${document.slice(2, 5)}.${document.slice(5)}`;
    if (document.length <= 12) return `${document.slice(0, 2)}.${document.slice(2, 5)}.${document.slice(5, 8)}/${document.slice(8)}`;

    return `${document.slice(0, 2)}.${document.slice(2, 5)}.${document.slice(5, 8)}/${document.slice(8, 12)}-${document.slice(12)}`;
};

export const maskDocument = (value) => {
    const document = sanitizeDocument(value);
    const isCNPJ = /[A-Z]/.test(document) || document.length > 11;

    if (!document) return "";

    return isCNPJ ? maskCNPJ(document) : maskCPF(document);
};

export const maskCEP = (value) => {
    return value?.replace(/\D/g, "").replace(/(\d{5})(\d)/, "$1-$2").slice(0, 9);
};

export const maskPhone = (phone) => {
    return phone?.replace(/\D/g, "").replace(/^(\d{2})(\d)/, "($1) $2").replace(/(\d{4,5})(\d{4})$/, "$1-$2").slice(0, 15);
};

export const maskCreditCard = (value) => {
    return value
        ?.replace(/\D/g, "")
        .replace(/(.{4})/g, "$1 ")
        .trim();
};

export const normalizeIdentifier = (value) => {
    const clean = sanitizeDocument(value);

    if (!clean) return "";
    if (/[A-Z]/.test(clean)) return clean;
    if (clean.length <= 11) return clean.slice(0, 11);

    return clean;
};

export const formatIdentifier = (value) => {
    return maskDocument(value);
};
